var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIconQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#BBBBBB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#BBBBBB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 38,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIconQuote);
export default __webpack_public_path__ + "static/media/template-icon-quote.ef58321bc4ad0f36a59dfa93546511eb.svg";
export { ForwardRef as ReactComponent };